import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/Layout'
import PageContent from '../components/PageContent'


const Page = ({ data }) => {
  
  const { wpPage: page } = data

  return (
    
      <Layout>
        <PageContent title={page.title} subtitle={page.pageOptions.subtitle} content={page.content} parentSlug={page.wpParent} />
      </Layout>
       
  )
}

export default Page

export const pageQuery = graphql`
  query PageById($id: String!) {
    wpPage(id: { eq: $id }) {
      title
      content
      pageOptions {
        subtitle
      }
      wpParent {
        node {
          slug
        }
      }
    }
  }
`